import React from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { CgClose } from "react-icons/cg";
import { useState } from "react";
import MergeList from "../MergeList/MergeList";
import AddMergeItem from "../AddMergeItem/AddMergeItem";

export const MergeFilesModal = ({ handleClose, show, items, id }) => {
  const [status, setStatus] = useState(false);

  return (
    <BootstrapModal
      modaltitle="زیرمجموعه ها"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        {!status ? (
          <>
            <div className="col-12">
              <Button
                bgColor="#009EF7"
                color="#fff"
                onclick={() => setStatus(!status)}
              >
                افزودن زیرمجموعه
              </Button>
            </div>
            <MergeList handleClose={handleClose} id={id} />
          </>
        ) : (
          <>
            <AddMergeItem id={id} setStatus={setStatus} status={status} />
          </>
        )}
      </div>
    </BootstrapModal>
  );
};

export default MergeFilesModal;
